import { Grid } from "@material-ui/core";
import React from "react";
import Loader from "react-spinners/BarLoader";
import CashoutItem from "./CashoutItem";
const Pendingcashout = ({ loading, cashoutList }) => {
  if (loading) {
    return <Loader loading={loading} />;
  }
  return (
    <div>
      <Grid container spacing={5}>
        {cashoutList?.map((cs) => (
          <Grid item xs={12} sm={6} md={4}>
            <CashoutItem cashout={cs} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Pendingcashout;
